$(function () {

    $(".wow").each(function (index, element) {
        var elementOffsetBottom = element.offsetTop + $(element).outerHeight();
        if ((element.offsetTop > window.pageYOffset && element.offsetTop < (window.pageYOffset + $(window).height())) ||
            ((elementOffsetBottom > window.pageYOffset) && (elementOffsetBottom < (window.pageYOffset + $(window).height())))) {
            $(element).removeClass("wow");
            if ($(element).css("visibility") !== "visible") {
                $(element).css("visibility", "visible");
            }
        }
    });

    let animate = getCookie("animate");
    if (animate !== "0") {
        if ($(".wow").length > 0) {
            new WOW().init();
        }
    }
});